/**
 * Owl carousel helper
 * @version 1.0.0
 * @author Rene Volbach
 * @license The MIT License (MIT)
 */
(function ($) {
  var property;
  var limit;
  var viewport;
  var settings;
  /**
   * Create owl helper class
   */
  var SwiperRetina = function () {
  };

  property = '';
  limit = '';
  viewport = {
    w: 0,
    h: 0,
    x: 0
  };

  SwiperRetina.prototype = {
    $slider: '',
    reUrl: /^\s*(\S*)/,
    reWidth: /\S\s+(\d+)w/,
    reHeight: /\S\s+(\d+)h/,
    reDpr: /\S\s+([\d.]+)x/,
    infty: [0, Infinity],
    one: [0, 1],
    srcsetOptions: {
      srcsetAttr: 'data-srcset'
    },

    set_slider: function ($object) {
      this.$slider = $object;
    },

    before_init: function () {
      var parent = this;

      parent.$slider.find(settings.imageSelector + '[' + parent.srcsetOptions.srcsetAttr + ']')
        .each(function () {
          var $this = $(this);
          var url = parent.check_rsp_data_src($this);
          if (url === false || url === '1x' || url === '2x') {
            $this.removeAttr(parent.srcsetOptions.srcsetAttr);
            return;
          }
          $this.attr('data-src', url);
        });
    },

    mathFilter: function (array, action) {
      return Math[action].apply(null, $.map(array, function (item) {
        return item[property];
      }));
    },

    check_rsp_data_src: function ($el) {
      var parent = this;
      var srcset;
      var list;
      var documentElement;
      var src;

      function compareMax(item) {
        return item[property] >= viewport[property] || item[property] === limit;
      }

      function compareMin(item) {
        return item[property] === limit;
      }

      srcset = $el.attr(parent.srcsetOptions.srcsetAttr);

      if (!srcset) {
        return false;
      }

      list = srcset.split(',').map(function (item) {
        return {
          url: parent.reUrl.exec(item)[1],
          w: parseFloat((parent.reWidth.exec(item) || parent.infty)[1]),
          h: parseFloat((parent.reHeight.exec(item) || parent.infty)[1]),
          x: parseFloat((parent.reDpr.exec(item) || parent.one)[1])
        };
      });

      if (!list.length) {
        return false;
      }

      documentElement = document.documentElement;

      viewport = {
        w: window.innerWidth || documentElement.clientWidth,
        h: window.innerHeight || documentElement.clientHeight,
        x: window.devicePixelRatio || 1
      };

      // Notice for DOMtastic users: currently $.grep method is not implemented in DOMtastic

      Object.keys(viewport).forEach(function (key) {
        if (key) {
          property = key;
          limit = parent.mathFilter(list, 'max');
          list = $.grep(list, compareMax);
        }
      });

      Object.keys(viewport).forEach(function (key) {
        if (key) {
          property = key;
          limit = parent.mathFilter(list, 'min');
          list = $.grep(list, compareMin);
        }
      });
      src = list[0].url;

      return src;
    }
  };

  /**
   * jQuery plugin function
   * @param options
   * @returns {*}
   */
  $.fn.swiperCarouselRetina = function (options) {
    var swiperRetina;

    // default options.
    settings = $.extend({
      beforeInit: false,
      imageSelector: '.swiper-lazy',
      nextSlideIsShown: false
    }, options);

    // callback
    swiperRetina = new SwiperRetina();
    swiperRetina.set_slider(this);

    if (settings.beforeInit) {
      return swiperRetina.before_init();
    }

    return false;
  };
}(jQuery));
